<div
    class="d-flex flex-column align-items-center justify-content-center gap-2 p-2"
>
    <img
        ngOptimizedImage
        ngSrc="../../assets/images/genai-home.png"
        alt="GenAI Reflection Tool"
        class="home-image img-fluid mb-4"
        width="400"
        height="400"
        priority
    />

    <h1 class="title" i18n>Generative AI - A four-step reflection tool</h1>

    <h2>🌍 🚀 🌙 ✨</h2>

    <p i18n>Click here to begin</p>

    <a class="btn btn-outline-secondary" [routerLink]="['/', 'intro']" (click)="markAsStarted()" i18n>
        Start
    </a>

    @if (languages && !loading) {
    <div class="btn-group mt-4" role="group" aria-label="Language selection">
        @for (language of languages; track language.code) {
        <input
            id="{{ language.code }}"
            class="btn-check"
            type="radio"
            name="language"
            value="{{ language.code }}"
            autocomplete="off"
            [checked]="language.code == currentLanguage"
            (click)="setLanguage(language.code)"
        />
        <label
            class="btn btn-outline-secondary"
            for="{{ language.code }}"
            i18n
            >{{ language.name }}</label
        >
        }
    </div>
    }
</div>

<div class="attribution-banner mt-4">
    <p i18n>
        This application has been developed by
        <a href="mailto:p.huijnen@uu.nl">Pim Huijnen</a> and
        <a href="mailto:s.falcke@uu.nl">Swantje Falcke</a> in collaboration with
        the
        <a href="https://cdh.uu.nl/">Centre for Digital Humanities</a> within
        the context of the USO project
        <a
            href="https://teaching-and-learning-collection.sites.uu.nl/project/ai-in-higher-education/"
            >"AI in Higher Education: Building reflective awareness through
            educational interventions"</a
        >.
    </p>
    <p class="mb-0 mt-1">
        <img
            src="../../assets/images/by-nc.eu.svg"
            alt="CC BY-NC"
            class="me-2 cc-logo"
        />
        <small i18n
            >You are free to share and adapt the contents of this site, if you
            give appropriate credit and use it non-commercially. More on
            <a
                href="https://creativecommons.org/licenses/by-nc/4.0/"
                target="_blank"
                rel="noopener"
                >Creative Commons</a
            >.</small
        >
    </p>
</div>
